import { TrackingPageModel } from '../tracking-page.model';
import { getAsset, getProductItems } from './helpers';
import {
  getFontConfig,
  getSocialIcons,
  getImage,
  getFooterItems,
  getLogo,
  getLanguageMenu,
  white
} from './helpers';

export const beauty: TrackingPageModel = {
  languageMenu: getLanguageMenu('Karla', '#272727ff'),
  searchPageInput: {
    backgroundColor: white,
    shadow: 'none',
    borderColor: '#ced4da',
    borderWidth: 1,
    borderRadius: 4,
    ...getFontConfig('Libre Franklin', '#6d788c')
  },
  searchPageTitle: {
    fontSize: 18,
    ...getFontConfig('Libre Franklin', '#272727b3')
  },
  background: {
    color: white,
    useBackgroundImage: false,
    imageUrl: getImage('/assets/img/tracking-page/Img_map_white.png'),
    backgroundMode: 'cover',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat'
  },
  card: {
    linksColor: '#272727ff',
    linksUnderline: true,
    backgroundColor: white,
    headerBackground: white,
    footerBackground: white,
    borderColor: '#27272733',
    borderRadius: 2,
    borderWidth: 1,
    shadow: 'none',
    trackingNumberField: 'trackingNumber',
    ...getFontConfig('Libre Franklin', '#272727b3')
  },
  orderCard: {
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#27272733',
    backgroundColor: white,
    shadow: 'none',
    footerBackground: white,
    headerBackground: white,
    linksColor: '#5780ff',
    linksUnderline: false,
    ...getFontConfig('Libre Franklin', '#272727b3')
  },
  orderNumber: {
    alignment: 'center',
    fontSize: 16,
    ...getFontConfig('Libre Franklin', '#272727ff')
  },
  orderStatus: {
    alignment: 'center',
    fontSize: 20,
    ...getFontConfig('Libre Franklin', '#212121ff', '700')
  },
  orderLastUpdated: {
    alignment: 'center',
    fontSize: 11,
    ...getFontConfig('Libre Franklin', '#272727b3')
  },
  notYetShippedItemsTitle: {
    alignment: 'center',
    fontSize: 14,
    ...getFontConfig('Libre Franklin', '#349534ff')
  },
  orderStatusOn: true,
  orderNumberOn: true,
  orderLastUpdatedOn: true,
  orderItemsFrame: {
    on: true,
    shadow: 'none',
    borderColor: '#27272733',
    borderRadius: 4,
    borderWidth: 1,
    backgroundColor: '#ffffff',
    button: {
      on: true,
      backgroundColor: '#272727',
      borderColor: '#00000000',
      borderRadius: 4,
      borderWidth: 1,
      shadow: 'none',
      ...getFontConfig('Source Sans Pro', white)
    },
    itemsLimit: 4,
    scroll: false,
    itemCard: {
      backgroundColor: '#ffffff00',
      borderColor: '#27272733',
      borderRadius: 4,
      borderWidth: 1,
      shadow: 'none',
      title: {
        alignment: 'left',
        fontSize: 17,
        ...getFontConfig('Libre Franklin', '#272727ff', '900')
      },
      info: {
        alignment: 'left',
        fontSize: 15,
        ...getFontConfig('Libre Franklin', '#272727b3')
      },
      showAttributes: false
    }
  },
  searchButton: {
    on: true,
    backgroundColor: '#222222ff',
    borderColor: '#27272700',
    borderRadius: 2,
    borderWidth: 2,
    shadow: 'none',
    ...getFontConfig('Karla', '#ffffffff')
  },
  detailsButton: {
    on: null,
    backgroundColor: '#272727ff',
    borderColor: '#00ccffff',
    borderRadius: 2,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Source Sans Pro', white)
  },
  trackButton: {
    on: null,
    backgroundColor: '#272727ff',
    borderColor: '#ee7227',
    borderRadius: 2,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Karla', white)
  },
  pageScroll: {
    scrollColor: '#00000033',
    borderRadius: 4,
    backgroundColor: '#ffffff00'
  },
  scripts: {
    head: null,
    body: null
  },
  logo: getLogo(getAsset('/images/themes/5c98f137e7657_logo-x35-2x.jpg')),
  socialIcons: getSocialIcons('#272727ff'),
  sidebar: {
    parcelIcon: 'icon-parcel',
    groupIcon: 'icon-track_number',
    backgroundColor: white,
    borderColor: '#27272733',
    borderRadius: 2,
    borderWidth: 1,
    sidebarField: 'orderNumbers',
    shadow: 'none',
    ...getFontConfig('Libre Franklin', '#272727b3')
  },
  footer: {
    linksColor: '#272727ff',
    linksUnderline: true,
    backgroundColor: white,
    ...getFooterItems(),
    ...getFontConfig('Libre Franklin', '#272727b3')
  },
  header: {
    backgroundColor: '#ffd7d7ff'
  },
  faviconUrl: '/assets/favicon/favicon-32x32.png',
  sidebarProductsFeed: {
    on: true,
    backgroundColor: white,
    borderColor: '#27272733',
    borderRadius: 2,
    borderWidth: 1,
    shadow: 'none',
    card: {
      backgroundColor: white,
      borderColor: '#27272733',
      borderRadius: 2,
      borderWidth: 0,
      shadow: 'none',
      button: {
        backgroundColor: '#272727ff',
        borderColor: '#00ccffff',
        borderRadius: 2,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Source Sans Pro', white)
      },
      buttonText: 'Buy Now',
      title: {
        alignment: 'center',
        fontSize: 15,
        ...getFontConfig('Libre Franklin', '#272727ff', '700')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Libre Franklin', '#272727b3')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 12,
        ...getFontConfig('Libre Franklin', '#159016ff', '700')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('sidebar'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#272727ff',
      arrowSize: 24
    }
  },
  mainProductsFeed: {
    on: true,
    backgroundColor: white,
    borderColor: '#27272733',
    borderRadius: 2,
    borderWidth: 1,
    shadow: 'none',
    card: {
      backgroundColor: white,
      borderColor: '#27272733',
      borderRadius: 2,
      borderWidth: 1,
      shadow: 'none',
      button: {
        backgroundColor: '#272727ff',
        borderColor: '#00ccffff',
        borderRadius: 2,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Source Sans Pro', white)
      },
      buttonText: 'Buy Now',
      title: {
        alignment: 'center',
        fontSize: 15,
        ...getFontConfig('Libre Franklin', '#000000ff', '700')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Libre Franklin', '#272727b3')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 12,
        ...getFontConfig('Libre Franklin', '#176d23ff', '700')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('main'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#272727ff',
      arrowSize: 24
    }
  },
  seoTitle: ''
};
